import { useMemo } from 'react';
import { ProjectId } from 'api/models';
import {
  useProjectPhaseByProjectId,
  useSprintsByProjectId,
} from 'data/projects';
import { useTasksFromStoreRQ } from 'data/tasks/hooks';
import { getPhaseList, getSprintList, getTaskList } from './timeline/helpers';

export const useListData = (projectId: number) => {
  const tasks = useTasksFromStoreRQ(ProjectId(projectId));
  const sprints = useSprintsByProjectId(projectId);
  const projectPhases = useProjectPhaseByProjectId(projectId);

  const phaseList = useMemo(
    () => getPhaseList(projectPhases ?? []),
    [projectPhases],
  );
  const taskList = useMemo(
    () => getTaskList(tasks ?? [], phaseList),
    [phaseList, tasks],
  );
  const sprintList = useMemo(
    () => getSprintList(sprints ?? [], phaseList),
    [phaseList, sprints],
  );

  return {
    taskList,
    sprintList,
    phaseList,
    tasks,
    sprints: sprints ?? [],
    projectPhases,
  };
};
